import { CSSProperties } from "react";
import { SpringConfig, config } from "react-spring";

interface ITransition {
	from: CSSProperties;
	enter: CSSProperties;
	leave: CSSProperties;
	config?: SpringConfig;
}

const swipeLeft: ITransition = {
	from: {
		opacity: 0,
		transform: "translate3d(50%,0,0)",
		position: "absolute",
	},
	enter: {
		opacity: 1,
		transform: "translate3d(0,0,0)",
		position: "static",
	},
	leave: {
		opacity: 0,
		transform: "translate3d(-50%,0,0)",
		position: "absolute",
	},
};

const swipeDown: ITransition = {
	from: {
		opacity: 0,
		transform: "translate3d(0,50%,0)",
		position: "absolute",
		width: "100%",
	},
	enter: {
		opacity: 1,
		transform: "translate3d(0,0,0)",
		position: "relative",
		width: "100%",
	},
	leave: {
		opacity: 0,
		transform: "translate3d(0,-50%,0)",
		position: "absolute",
		width: "100%",
	},
};

const fade: ITransition = {
	from: { opacity: 0 },
	enter: { opacity: 1 },
	leave: {
		display: "none",
	},
};

const zoom: ITransition = {
	from: {
		transform: "scale(0)",
		opacity: 0,
		position: "absolute",
		width: "100%",
	},
	enter: {
		transform: "scale(1)",
		opacity: 1,
		position: "absolute",
		width: "100%",
	},
	leave: {
		transform: "scale(2)",
		opacity: 0,
		position: "absolute",
		width: "100%",
	},
	config: { mass: 2, tension: 100, friction: 30, easing: (t) => t * t * t },
};

export default {
	swipeLeft,
	swipeDown,
	fade,
	zoom,
};
